import { IOverlayItem } from 'components/MapboxMap/OverlayControl/OverlayControl'

import { LOCALIZATION_MODE_LIDAR } from './setPoseUi'

export function buildLaserscanOverlayItem(params: {
  localizationMode?: number
  laserscanActive: boolean
  robotId?: number
  onToggle: () => void | Promise<void>
}): IOverlayItem | null {
  if (params.localizationMode !== LOCALIZATION_MODE_LIDAR) return null

  return {
    onClick: params.onToggle,
    active: params.laserscanActive,
    disabled: !params.robotId,
    content: <>Laserscan</>,
  }
}
